import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Import from "@/pages/Import";
import ContactProfile from "@/pages/ContactProfile";
import Pipeline from "@/pages/Pipeline";
import Approvals from "@/pages/Approvals";
import Templates from "@/pages/Templates";
import AiAssistant from "@/pages/AiAssistant";
import Forms from "@/pages/Forms";
import Settings from "@/pages/Settings";
import Help from "@/pages/Help";

function ProtectedRoute({ children }) {
  const { token, ready } = useAuth();
  if (!ready) return (
    <div className="min-h-screen flex items-center justify-center text-slate-500">
      Loading…
    </div>
  );
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute><AppLayout /></ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="leads" element={<Leads />} />
            <Route path="leads/import" element={<Import />} />
            <Route path="contacts/:id" element={<ContactProfile />} />
            <Route path="pipeline" element={<Pipeline />} />
            <Route path="approvals" element={<Approvals />} />
            <Route path="templates" element={<Templates />} />
            <Route path="forms" element={<Forms />} />
            <Route path="settings" element={<Settings />} />
            <Route path="assistant" element={<AiAssistant />} />
            <Route path="help" element={<Help />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
